import React from 'react';

export function Header({ usuarioActual, menu, setMenu, menusVisibles, onLogout }) {
  return (
    <div style={{ backgroundColor: '#1a3a6e', padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ backgroundColor: '#f97316', width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ color: 'white', fontWeight: 800, fontSize: 18 }}>R</span>
        </div>
        <span style={{ color: 'white', fontWeight: 700, fontSize: 19 }}>Sistema de Referidos</span>
      </div>

      <nav style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        {menusVisibles.map((m) => (
          <button
            key={m}
            onClick={() => setMenu(m)}
            style={{
              padding: '8px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 600,
              backgroundColor: menu === m ? '#f97316' : 'transparent',
              color: 'white',
            }}
          >
            {m}
          </button>
        ))}
      </nav>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ color: '#cbd5e1', fontSize: 13 }}>{usuarioActual?.nombre_usuario}</span>
        <button
          onClick={onLogout}
          style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #f97316', background: 'transparent', color: '#f97316', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
        >
          Salir
        </button>
      </div>
    </div>
  );
}

export function Footer() {
  return (
    <div style={{ textAlign: 'center', padding: '16px 24px', color: '#9ca3af', fontSize: 12, borderTop: '1px solid #e5e7eb', marginTop: 40 }}>
      © {new Date().getFullYear()} Sistema de Referidos — Desarrollado por Rueli TI
    </div>
  );
}

export const styles = {
  page: { maxWidth: 1200, margin: '0 auto', padding: '24px' },
  card: { background: 'white', borderRadius: 10, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: 20 },
  sectionTitle: { fontSize: 18, fontWeight: 700, color: '#1a3a6e', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #f97316' },
  th: { backgroundColor: '#1a3a6e', color: 'white', padding: '10px 12px', textAlign: 'left', fontSize: 13 },
  td: { padding: '10px 12px', borderBottom: '1px solid #eee', fontSize: 13 },
  btnPrimary: { backgroundColor: '#1a3a6e', color: 'white', border: 'none', borderRadius: 6, padding: '9px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13 },
  btnAccent: { backgroundColor: '#f97316', color: 'white', border: 'none', borderRadius: 6, padding: '9px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13 },
  btnGhost: { backgroundColor: 'transparent', color: '#1a3a6e', border: '1px solid #1a3a6e', borderRadius: 6, padding: '7px 12px', cursor: 'pointer', fontWeight: 600, fontSize: 12 },
  btnDanger: { backgroundColor: 'transparent', color: '#dc2626', border: '1px solid #dc2626', borderRadius: 6, padding: '7px 12px', cursor: 'pointer', fontWeight: 600, fontSize: 12 },
  input: { width: '100%', padding: 9, borderRadius: 6, border: '1px solid #d1d5db', boxSizing: 'border-box', fontSize: 13 },
  label: { display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, marginTop: 10 },
};
